import React from "react";
import {inject, observer} from "mobx-react";
import {observable} from "mobx";
import {IAuthStore, SetupCode2FA} from "Stores/Auth/types";
import {Values} from "Tools/Values";
import Setup2FA from "./Setup2FA/Setup2FA";
import {Enable2FAContentContainer, ActionButton, Enable2FAContent} from "../styles";
import OTPInputForm from "@src/Components/Ui/OTPInputForm/OTPInputForm";
import { Toast } from "../../../../../../Tools/Toast";

interface IProps {
    auth?: IAuthStore;
}

@inject("auth")
@observer
export default class Enable2FA extends React.Component<IProps> {
    @observable otpCode: string = '';
    @observable isLoading: boolean = false;
    @observable isValid: boolean = true;
    @observable setup: SetupCode2FA = {setupUrl: '', setupCode: ''};

    componentDidMount = async () => {
        if (await this.props.auth.Is2FASetupRequired()) {
            const toast = new Toast();
            const message = Values.getLocalizationValue("twoFactorAuthIsRequiredMessage");
            toast.showError(message);
        }

        this.setup = await this.props.auth.get2FASetup();
    }

    handleOtpChange(code: string) {
        this.otpCode = code;
        if (!this.isValid) {
            this.isValid = true;
        }
    }

    async handleEnable2FA() {
        const isEnabled = await this.props.auth.enable2FA(this.otpCode);
        if (!isEnabled) {
            this.setup = await this.props.auth.get2FASetup();
            this.isValid = false;
        }
    }

    async handleSubmit() {
        if (this.isLoading) return;

        this.isLoading = true;
        await this.handleEnable2FA();
        this.isLoading = false;
    }

    render() {
        return (
            <Enable2FAContent>
                <Setup2FA setup={this.setup}/>

                <Enable2FAContentContainer>
                    <span>
                        {Values.getLocalizationValue('enterThe6DigitCodeFromAuthenticationApp')}:
                    </span>

                    <OTPInputForm
                        value={this.otpCode}
                        onChange={(code) => this.handleOtpChange(code)}
                        handleSubmit={this.handleSubmit.bind(this)}
                        disabled={this.isLoading}
                        autoSubmit={true}
                        error={!this.isValid}
                    />

                    <ActionButton
                        onClick={this.handleSubmit.bind(this)}
                        disabled={this.otpCode.length !== 6}
                    >
                        {Values.getLocalizationValue('save')}
                    </ActionButton>
                </Enable2FAContentContainer>
            </Enable2FAContent>
        );
    }
}
